webpackJsonp([1],{

/***/ 104:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 105:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 106:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(175)
}
var Component = __webpack_require__(212)(
  /* script */
  __webpack_require__(109),
  /* template */
  __webpack_require__(213),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 108:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_spectre_css_dist_spectre_min_css__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_spectre_css_dist_spectre_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_spectre_css_dist_spectre_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_spectre_css_dist_spectre_icons_min_css__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_spectre_css_dist_spectre_icons_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_spectre_css_dist_spectre_icons_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_3__App___default.a }
});

/***/ }),

/***/ 109:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_papaparse__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_papaparse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_papaparse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_file_saver__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jszip__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jszip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_jszip__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      csv: {},
      search: '',
      groups: {},
      files: [],
      incomingFiles: [],
      csvDropActive: false,
      showModal: false,
      activeTab: 'G',
      groupsImportData: '',
      selectedLanguage: 'en',
      lang: {
        en: {
          identifierPrefixLength: 11,
          identifier: 'Identifier',
          group: 'Group',
          grade: 'Grade',
          gradeMax: 'Maximum Grade',
          feedback: 'Feedback comments'
        },
        fr: {
          identifierPrefixLength: 11,
          identifier: 'Identifiant',
          group: 'Groupe',
          grade: 'Note',
          gradeMax: 'Note maximale',
          feedback: 'Feedback par commentaires'
        }
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    if (window.location.search) {
      var url = window.location.search.split('?url=')[1];
      this.downloadFile(url).then(function (data) {
        _this.incomingFiles = data;
      });
    }
  },

  computed: {
    filteredStudents: function filteredStudents() {
      var _this2 = this;

      return this.csv.data.filter(function (student) {
        return _this2.csv.meta.fields.some(function (field) {
          return student[field].toLowerCase().indexOf(_this2.search.toLowerCase()) > -1;
        });
      });
    },
    filteredGroups: function filteredGroups() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(this.groups).filter(function (group) {
        return group.toLowerCase().indexOf(_this3.search.toLowerCase()) > -1;
      }).sort();
    },
    langLookup: function langLookup() {
      return this.lang[this.selectedLanguage];
    }
  },
  methods: {
    reset: function reset() {
      this.csv = {};
      this.files = [];
      this.search = '';
    },
    parse: function parse() {
      var _this4 = this;

      if (this.$refs.fileInput.files.length < 1) {
        this.csv = {};
        this.groups = {};
        return;
      }
      __WEBPACK_IMPORTED_MODULE_5_papaparse___default.a.parse(this.$refs.fileInput.files[0], {
        header: true,
        skipEmptyLines: true,
        complete: function complete(response) {
          _this4.csv = response;
          // detect language
          var foundLang = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(_this4.lang).find(function (lang) {
            return _this4.lang[lang].identifier === _this4.csv.meta.fields[0];
          });
          if (foundLang) {
            _this4.selectedLanguage = foundLang;
          }
          [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a(_this4.csv.data.map(function (student) {
            return student[_this4.langLookup.group];
          })))).forEach(function (group) {
            var obj = {};
            obj[_this4.langLookup.grade] = '';
            obj[_this4.langLookup.feedback] = '';
            _this4.$set(_this4.groups, group, obj);
          });
        }
      });
    },
    importGroupFeedback: function importGroupFeedback() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_5_papaparse___default.a.parse(this.groupsImportData, {
        header: false,
        skipEmptyLines: true,
        complete: function complete(response) {
          response.data.forEach(function (row) {
            var group = row[0];
            var grade = row[1];
            var feedback = row[2];
            var obj = {};
            obj[_this5.langLookup.grade] = grade;
            obj[_this5.langLookup.feedback] = feedback;
            _this5.$set(_this5.groups, group, obj);
            _this5.updateGroupField({ target: { value: grade } }, group, _this5.langLookup.grade);
            _this5.updateGroupField({ target: { value: feedback } }, group, _this5.langLookup.feedback);
          });
        }
      });
    },
    unparse: function unparse() {
      var csv = __WEBPACK_IMPORTED_MODULE_5_papaparse___default.a.unparse(this.csv.data, {
        quotes: true,
        newline: this.csv.meta.linebreak,
        delimiter: this.csv.meta.delimiter
      });
      var blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
      __WEBPACK_IMPORTED_MODULE_6_file_saver___default.a.saveAs(blob, 'out.csv');
    },
    findFile: function findFile(group) {
      return this.files.find(function (file) {
        return file.name.indexOf(group) > -1;
      });
    },
    filenameForGroup: function filenameForGroup(group) {
      var file = this.findFile(group);
      return file ? file.name : '';
    },
    zip: function zip() {
      var _this6 = this;

      this.showModal = true;
      var zip = new __WEBPACK_IMPORTED_MODULE_7_jszip___default.a();
      this.csv.data.forEach(function (student) {
        var file = _this6.findFile(student[_this6.langLookup.group]);
        if (file) {
          var id = student[_this6.langLookup.identifier].slice(_this6.langLookup.identifierPrefixLength);
          var group = student[_this6.langLookup.group];
          var extension = file.name.split('.').pop();
          zip.file(group + '_' + id + '_assignsubmission_file_Feedback-' + group + '.' + extension, file);
        }
      });
      zip.generateAsync({ type: 'blob' }).then(function (blob) {
        __WEBPACK_IMPORTED_MODULE_6_file_saver___default.a.saveAs(blob, 'upload.zip');
        _this6.showModal = false;
      });
    },
    isEditableNumber: function isEditableNumber(field) {
      return [this.langLookup.grade].indexOf(field) > -1;
    },
    isEditableTextarea: function isEditableTextarea(field) {
      return [this.langLookup.feedback].indexOf(field) > -1;
    },
    updateGroupField: function updateGroupField($event, group, field) {
      var _this7 = this;

      this.csv.data.forEach(function (student) {
        if (student[_this7.langLookup.group] === group) {
          // eslint-disable-next-line
          student[field] = $event.target.value;
        }
      });
    },
    groupFillDownFrom: function groupFillDownFrom(i) {
      var _this8 = this;

      var source = this.groups[this.filteredGroups[i]];
      this.filteredGroups.slice(i + 1).forEach(function (group) {
        _this8.groups[group][_this8.langLookup.grade] = source[_this8.langLookup.grade];
        _this8.groups[group][_this8.langLookup.feedback] = source[_this8.langLookup.feedback];
        _this8.csv.data.forEach(function (student) {
          if (student[_this8.langLookup.group] === group) {
            // eslint-disable-next-line
            student[_this8.langLookup.grade] = source[_this8.langLookup.grade];
            // eslint-disable-next-line
            student[_this8.langLookup.feedback] = source[_this8.langLookup.feedback];
          }
        });
      });
    },
    filterGroup: function filterGroup(group) {
      if (this.search === group) {
        this.search = '';
      } else {
        this.search = group;
      }
    },
    unzip: function unzip(file) {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_7_jszip___default.a.loadAsync(file).then(function (zip) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(zip.files).map(function (zipEntry) {
          return zipEntry.async('uint8array').then(function (content) {
            return new File(content, zipEntry.name);
          });
        })).then(function (files) {
          return _this9.addFiles(files);
        });
      }, function (e) {
        console.log(e);
      });
    },
    handleFeedbackFiles: function handleFeedbackFiles() {
      var _this10 = this;

      this.showModal = true;
      this.addFiles([].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(this.$refs.feedbackInput.files))).then(function () {
        _this10.showModal = false;
        _this10.$refs.feedbackInput.value = null;
      });
    },
    downloadFile: function downloadFile(url) {
      var _this11 = this;

      if (url.indexOf('http') === 0) {
        return fetch(url, {
          method: 'GET'
        }).then(function (response) {
          return response.blob();
        }).then(function (blob) {
          // eslint-disable-next-line
          blob.lastModifiedDate = new Date();
          // eslint-disable-next-line
          blob.name = url.split('/').pop();
          return _this11.addFiles([blob]);
        });
      }
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve([]);
    },
    addFiles: function addFiles(files) {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(files.map(function (file) {
        if (file.name.indexOf('.zip') >= 0) {
          return _this12.unzip(file);
        }
        if (file.name.indexOf('.json') >= 0) {
          return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            var fr = new FileReader();
            fr.onload = function (e) {
              if (e.error) {
                reject(e.error);
              }
              try {
                __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(JSON.parse(e.target.result).map(function (url) {
                  return _this12.downloadFile(url);
                })).then(function (fileNames) {
                  var _ref;

                  return resolve((_ref = []).concat.apply(_ref, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(fileNames)));
                });
              } catch (e2) {
                resolve();
              }
            };
            fr.readAsText(file);
          });
        }
        _this12.files.push(file);
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(file.name);
      })).then(function (fileNames) {
        var _ref2;

        return (_ref2 = []).concat.apply(_ref2, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(fileNames));
      });
    }
  }
});

/***/ }),

/***/ 175:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 213:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('header', [_c('section', {
    staticClass: "container grid-960"
  }, [_c('nav', {
    staticClass: "navbar"
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "navbar-section"
  }, [_c('div', {
    staticClass: "input-group input-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "placeholder": "search"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-action ml-10",
    attrs: {
      "title": "reset"
    },
    on: {
      "click": _vm.reset
    }
  }, [_c('i', {
    staticClass: "icon icon-refresh"
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content container grid-960"
  }, [(_vm.csv.errors && _vm.csv.errors.length > 0) ? _c('div', {
    staticClass: "toast toast-error"
  }, _vm._l((_vm.csv.errors), function(e) {
    return _c('p', [_c('strong', [_vm._v(_vm._s(e.type) + " (row: " + _vm._s(e.row) + "):")]), _vm._v(" " + _vm._s(e.message) + ".\n      ")])
  })) : _vm._e(), _vm._v(" "), (_vm.incomingFiles.length > 0 && !_vm.csv.meta) ? _c('div', {
    staticClass: "toast"
  }, [_vm._v("\n      Downloaded incoming files for you: " + _vm._s(_vm.incomingFiles.join(', ')) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.csv.meta),
      expression: "!csv.meta"
    }],
    staticClass: "empty file-drop-area",
    class: {
      'is-active': _vm.csvDropActive
    }
  }, [_vm._m(1), _vm._v(" "), _c('h4', {
    staticClass: "empty-title"
  }, [_vm._v("No CSV file uploaded")]), _vm._v(" "), _c('p', {
    staticClass: "empty-subtitle"
  }, [_vm._v("Drag and drop a CSV file here, or click the button.")]), _vm._v(" "), _c('div', {
    staticClass: "empty-action"
  }, [_c('button', {
    staticClass: "btn btn-primary"
  }, [_vm._v("Choose file")]), _vm._v(" "), _c('input', {
    ref: "fileInput",
    staticClass: "file-input",
    attrs: {
      "type": "file",
      "accept": ".csv, text/csv"
    },
    on: {
      "change": _vm.parse,
      "dragleave": function($event) {
        _vm.csvDropActive = false
      },
      "blur": function($event) {
        _vm.csvDropActive = false
      },
      "drop": function($event) {
        _vm.csvDropActive = false
      },
      "dragenter": function($event) {
        _vm.csvDropActive = true
      },
      "focus": function($event) {
        _vm.csvDropActive = true
      },
      "click": function($event) {
        _vm.csvDropActive = true
      }
    }
  })])]), _vm._v(" "), (_vm.csv.meta) ? _c('div', [_c('ul', {
    staticClass: "tab tab-block"
  }, [_c('li', {
    staticClass: "tab-item"
  }, [_c('a', {
    staticClass: "badge",
    class: {
      active: _vm.activeTab === 'G'
    },
    attrs: {
      "href": "#",
      "data-badge": _vm.filteredGroups.length
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.activeTab = 'G'
      }
    }
  }, [_vm._v("Groups")])]), _vm._v(" "), _c('li', {
    staticClass: "tab-item"
  }, [_c('a', {
    staticClass: "badge",
    class: {
      active: _vm.activeTab === 'F'
    },
    attrs: {
      "href": "#",
      "data-badge": _vm.files.length
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.activeTab = 'F'
      }
    }
  }, [_vm._v("Feedback Files")])]), _vm._v(" "), _c('li', {
    staticClass: "tab-item"
  }, [_c('a', {
    staticClass: "badge",
    class: {
      active: _vm.activeTab === 'S'
    },
    attrs: {
      "href": "#",
      "data-badge": _vm.filteredStudents.length
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.activeTab = 'S'
      }
    }
  }, [_vm._v("Participants")])]), _vm._v(" "), _c('li', {
    staticClass: "tab-item tab-action ml-10"
  }, [_c('div', {
    staticClass: "input-group input-inline"
  }, [_c('button', {
    staticClass: "btn btn-primary input-group-btn ml-10 mr-10",
    on: {
      "click": _vm.unparse
    }
  }, [_vm._v("Download CSV")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary input-group-btn ",
    on: {
      "click": _vm.zip
    }
  }, [_vm._v("Download ZIP")])])])]), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab === 'G'),
      expression: "activeTab === 'G'"
    }]
  }, [_c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.langLookup.group))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.langLookup.grade))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.langLookup.feedback))]), _vm._v(" "), _c('th', [_vm._v("Action")]), _vm._v(" "), _c('th', [_vm._v("File")])])]), _vm._v(" "), _c('transition-group', {
    attrs: {
      "name": "list",
      "tag": "tbody"
    }
  }, _vm._l((_vm.filteredGroups), function(group, $index) {
    return _c('tr', {
      key: group
    }, [_c('td', [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.filterGroup(group)
        }
      }
    }, [_vm._v(_vm._s(group))])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.groups[group][_vm.langLookup.grade]),
        expression: "groups[group][langLookup.grade]"
      }],
      staticClass: "grade",
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (_vm.groups[group][_vm.langLookup.grade])
      },
      on: {
        "change": function($event) {
          _vm.updateGroupField($event, group, _vm.langLookup.grade)
        },
        "keyup": function($event) {
          _vm.updateGroupField($event, group, _vm.langLookup.grade)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.groups[group], _vm.langLookup.grade, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.groups[group][_vm.langLookup.feedback]),
        expression: "groups[group][langLookup.feedback]"
      }],
      staticClass: "feedback",
      domProps: {
        "value": (_vm.groups[group][_vm.langLookup.feedback])
      },
      on: {
        "keyup": function($event) {
          _vm.updateGroupField($event, group, _vm.langLookup.feedback)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.groups[group], _vm.langLookup.feedback, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          _vm.groupFillDownFrom($index)
        }
      }
    }, [_c('i', {
      staticClass: "icon icon-downward"
    }), _vm._v(" Fill down")])]), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(_vm.filenameForGroup(group)) + "\n              ")])])
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "import"
    }
  }, [_vm._v("Import values group, grade, comment (no header, copy past from Excel\n            or CSV)")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.groupsImportData),
      expression: "groupsImportData"
    }],
    staticClass: "form-input",
    attrs: {
      "id": "import",
      "placeholder": "A01, 1, ",
      "rows": "3"
    },
    domProps: {
      "value": (_vm.groupsImportData)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.groupsImportData = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.importGroupFeedback
    }
  }, [_vm._v("Import")])]), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab === 'F'),
      expression: "activeTab === 'F'"
    }]
  }, [_c('div', {
    staticClass: "empty file-drop-area",
    class: {
      'is-active': _vm.csvDropActive
    }
  }, [_vm._m(2), _vm._v(" "), _c('h4', {
    staticClass: "empty-title"
  }, [_vm._v("Drag and drop feedback files or a zip with files")]), _vm._v(" "), _c('p', {
    staticClass: "empty-subtitle"
  }, [_vm._v("The feedback file should include the name of a group to be matched.")]), _vm._v(" "), _c('div', {
    staticClass: "empty-action"
  }, [_c('button', {
    staticClass: "btn btn-primary"
  }, [_vm._v("Choose file")]), _vm._v(" "), _c('input', {
    ref: "feedbackInput",
    staticClass: "file-input",
    attrs: {
      "type": "file",
      "multiple": ""
    },
    on: {
      "change": _vm.handleFeedbackFiles,
      "dragleave": function($event) {
        _vm.csvDropActive = false
      },
      "blur": function($event) {
        _vm.csvDropActive = false
      },
      "drop": function($event) {
        _vm.csvDropActive = false
      },
      "dragenter": function($event) {
        _vm.csvDropActive = true
      },
      "focus": function($event) {
        _vm.csvDropActive = true
      },
      "click": function($event) {
        _vm.csvDropActive = true
      }
    }
  })])]), _vm._v(" "), _c('ul', _vm._l((_vm.files), function(file) {
    return _c('li', [_vm._v(_vm._s(file.name))])
  }))]), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab === 'S'),
      expression: "activeTab === 'S'"
    }],
    staticStyle: {
      "overflow": "auto"
    }
  }, [(_vm.csv.meta) ? _c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', _vm._l((_vm.csv.meta.fields), function(field) {
    return _c('th', [_vm._v(_vm._s(field))])
  }))]), _vm._v(" "), _c('transition-group', {
    attrs: {
      "name": "list",
      "tag": "tbody"
    }
  }, _vm._l((_vm.filteredStudents), function(student) {
    return _c('tr', {
      key: student[_vm.langLookup.identifier]
    }, _vm._l((_vm.csv.meta.fields), function(field) {
      return _c('td', [(_vm.isEditableNumber(field)) ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (student[field]),
          expression: "student[field]"
        }],
        attrs: {
          "type": "number",
          "min": "0",
          "max": student[_vm.langLookup.gradeMax]
        },
        domProps: {
          "value": (student[field])
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(student, field, $event.target.value)
          }
        }
      }) : (_vm.isEditableTextarea(field)) ? _c('textarea', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (student[field]),
          expression: "student[field]"
        }],
        domProps: {
          "value": (student[field])
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(student, field, $event.target.value)
          }
        }
      }) : (field === _vm.langLookup.group) ? _c('a', {
        attrs: {
          "href": "#"
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.filterGroup(student[field])
          }
        }
      }, [_vm._v(_vm._s(student[field]))]) : _c('span', [_vm._v(_vm._s(student[field]))])])
    }))
  }))], 1) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    class: {
      active: _vm.showModal
    }
  }, [_c('div', {
    staticClass: "modal-overlay"
  }), _vm._v(" "), _vm._m(3)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "navbar-section"
  }, [_c('a', {
    staticClass: "navbar-brand mr-10",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Moodle Assignment Feedback Packager")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-link",
    attrs: {
      "href": "https://github.com/bfritscher/moodle-assignment-feedback-packager"
    }
  }, [_vm._v("GitHub")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "empty-icon"
  }, [_c('i', {
    staticClass: "icon icon-upload"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "empty-icon"
  }, [_c('i', {
    staticClass: "icon icon-upload"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('div', {
    staticClass: "modal-title"
  }, [_vm._v("Processing file(s)")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "loading"
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  })])
}]}

/***/ }),

/***/ 217:
/***/ (function(module, exports) {

/* (ignored) */

/***/ })

},[108]);


// WEBPACK FOOTER //
// static/js/app.de299fb59d2ef7f250b5.js